module.exports = __webpack_public_path__ + "static/4-8102c4838f9e3d08dad644290a9cb701.woff";